<!-- 首页跳转 校友卡 页面 -->
<template>
  <div class="alumniCardDiv">
    <div class="card">
      <div class="card-flex">
        <img src="../../assets/image/btn_logo_nor@2x.png" class="cardImg" />
        <div class="bh">编号：56868956</div>
        <img
          src="../../assets/image/btn_shuoming_nor.png"
          style="image-rendering: -webkit-optimize-contrast;"
          @click="nvliangDialog()"
        />
      </div>
      <img v-if="cardInfo.url != null && cardInfo.url != ''" :src="cardInfo.url" class="txImg" />
      <img v-else :src="defaultAvatar" alt="" class="txImg"/>
      <div class="name">{{ cardInfo.name }}</div>
      <div class="detail">
        <div class="detailD">
          <div>院&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;系：</div>
          <div>{{ cardInfo.college }}</div>
        </div>
        <div class="detailD">
          <div>专&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业：</div>
          <div>{{ cardInfo.major }}</div>
        </div>
        <div class="detailD">
          <div>毕&nbsp;业&nbsp;年&nbsp;份：</div>
          <div>{{ cardInfo.xuejie }}年</div>
        </div>
        <div class="segmentation"></div>
        <!-- <img :src="qrcode" class="ewmimg" /> -->
         <button
           v-if="isAuth"
           :disabled="isLoading"
           class="ewm-btn"
           @click="handleQrcodeClick"
         >
           <span v-if="!isLoading">跳转到一卡通二维码</span>
           <span v-else style="display:flex;align-items:center;justify-content:center;gap:8px;">
             <svg class="loading-spinner" width="22" height="22" viewBox="0 0 50 50">
               <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"/>
             </svg>
             跳转中...
           </span>
         </button>
         <span v-else class="ewm-tip">未查询到匹配的毕业生数据！</span>
      </div>
    </div>

    <van-dialog
      v-model="isNewNvliangDialog"
      :showConfirmButton="false"
      closeOnClickOverlay
      closeOnPopstate
      width="24.76rem"
    >
      <div class="active-list__new-activity-content">
        <img
          class="active-list__new-activity-content-bg"
          :src="BgNewActivityTop"
        />
        <div class="active-list__new-activity-content-main">
          <div class="active-list__new-activity-content-title">
            校友卡使用说明
          </div>
          <div class="active-list__new-activity-content-describe">
            <div>
              为了进一步体现母校对于校友的关爱，强化校友对于母校的归属感。沈阳工程学院校友，可在线申领校友卡。
            </div>
            <!-- <div style="margin-top: 0.5rem">现将有关事项通知如下：</div> -->
            <div style="margin-top: 2rem">校友卡功能</div>
            <div>{{ content }}</div>
            <!-- <div>1.凭校友卡作为身份标识，校友可方便出入校园；</div>
            <div>2.凭校友卡支付，校友可到校内任意食堂用餐和乘坐学校班车；</div>
            <div>
              3.凭校友卡支付，校友入住学院协议宾馆（国际交流中心、专家楼等）享受学习协议价格；
            </div> -->
          </div>
          <div
            class="active-list__new-activity-content-contact"
            @click="closeDialog()"
          >
            知道了
          </div>
        </div>
        <img
          class="active-list__new-activity-content-bg"
          :src="BgNewActivityBottom"
        />
      </div>
    </van-dialog>
  </div>
</template>
<script>
import BgNewActivityTop from "@/assets/image/active/btn_shang_nor.png";
import BgNewActivityBottom from "@/assets/image/active/btn_xia_nor.png";
import defaultAvatar from '@/assets/image/defaultAvatar.png'
import Base64 from "@/utils/base64";

export default {
  data() {
    return {
      userId: window.localStorage.getItem("user_id"),
      // userId: "43995354",
      defaultAvatar,
      BgNewActivityTop,
      BgNewActivityBottom,
      openid: this.$route.query.openid,
      cardInfo: [],
      photoUrl: "",
      token: "",
      codeImg: "",
      timer: "",
      percentage: 100,
      percentageTimer: "",
      isRealNam: "",
      isReal: "",
      isNewNvliangDialog: false,
      content:'',
      qrcode:'',
      isAuth: true,
      isLoading: false
    };
  },
  created() {
    this.getAlumnusCard();

  },

  methods: {
        handleQrcodeClick() {
          if (this.isLoading) return;
          this.isLoading = true;
          window.location.href = this.qrcode;
          // 可选：如需等待跳转后恢复按钮状态，可加定时器
          // setTimeout(() => { this.isLoading = false }, 3000);
        },
    async nvliangDialog() {
      const result = await this.$http.post("/alumniCard/getCardWords");
      this.content = result.data.content;
      this.isNewNvliangDialog = true;
    },
    closeDialog() {
      this.isNewNvliangDialog = false;
    },
    async getQRcode(){
      let base64 = new Base64()
      const res = await this.$http.get("/my/myQrCodePath", {
        params: { userId: base64.encode(this.userId) },
      });
      console.log(res)
      if (res.data.length < 20) {
        this.isAuth = false
      } else {
        this.qrcode = res.data
      }
    },
    // 实名认证你无关
    async realName() {
      if (this.$route.query.status == 1) {
        this.isReal = this.$route.query.status;
        // 存入实名认证状态
        const res = await this.$http({
          // url: `/realNameAuthentication/realNameStatus?userId=${data.userId}&realNameAuthentication=${data.realNameAuthentication}`,
          url: `/realNameAuthentication/realNameStatus?userId=${localStorage.getItem(
            "user_id"
          )}&realNameAuthentication=1`,

          method: "POST",
          // data:data,
        });
        if (res.data.code == 200) {
          localStorage.setItem("realStatus", this.isReal);
          this.$toast("实名认证成功");
        } else {
          this.$toast("实名认证失败");
        }
      }
    },
    // 校友卡获取
    async getAlumnusCard() {
      let base64 = new Base64()
      const result = await this.$http.get("/my/getBasic", {
        params: { userId: base64.encode(this.userId) },
      });
      this.cardInfo = result.data;
      this.getQRcode()
      // // TODO
      // this.getCodeImg();
    },
    async getData() {
      // const res = await this.$http.get(`/xjcard/recompletion?openid=${window.localStorage.getItem("openid")}`)
      const res = await this.$http.get(
        `/xjcard/recompletion?openid=${this.openid}`
      );
      if (res.data != null) {
        this.photoUrl = res.data.url;
      }
    },
    async getCodeImg() {
      const res = await this.$http.get(
        `/xjcard/QrcodeByalumnsId?alumnsId=${this.cardInfo.alumnusId}`,
        {}
      );
      this.codeImg = res.data.data.qrcode;
      this.percentage = 100;
    },
    currentTime() {
      this.timer = setInterval(this.getCodeImg, 10000);
    },
    countdown() {
      if (this.percentage <= 100 && this.percentage > 0) {
        this.percentage = this.percentage - 10;
      } else if (this.percentage < 1) {
        this.percentage = 100;
      }
    },
    countdownTime() {
      this.percentageTimer = setInterval(this.countdown, 1000);
    },
  },
};
</script>
<style lang="less" scoped>
    .loading-spinner {
      animation: spin 1s linear infinite;
      vertical-align: middle;
      /* 让SVG居中显示 */
      display: inline-block;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .loading-spinner .path {
      stroke: #fff;
      stroke-linecap: round;
      opacity: 0.8;
      stroke-dasharray: 90,150;
      stroke-dashoffset: 0;
    }
  .loading-spinner {
    animation: spin 1s linear infinite;
    vertical-align: middle;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .loading-spinner .path {
    stroke: #fff;
    stroke-linecap: round;
    opacity: 0.8;
  }
.alumniCardDiv {
  .card {
    // position: absolute;
    width: 90%;
    // height: 40%;
    // border: 1px solid #000;
    margin-left: 5%;
    margin-top: 2%;
    background-image: url(../../assets/image/cardBackImg.png);
    background-size: 100%, 100%;
    border-radius: 15px;
  }
  .card-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .cardImg {
    width: 37vw;
    margin: 10px 0px 0px 10px;
    // image-rendering: -webkit-optimize-contrast;
    object-fit: cover;
  }
  .bh {
    color: #fff;
    margin-left: 40px;
    margin-right: 15px;
    font-size: 0.85rem;
  }
  .txImg {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 2px solid #fff;
    margin-left: 36%;
    margin-top: 25%;
  }
  .name {
    text-align: center;
    font-size: 1.1rem;
    font-weight: 600;
    margin-top: 5px;
  }
  .detail {
    margin-top: 10px;
    width: 85%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #000;
    margin-left: 10%;
  }
  .detailD {
    display: flex;
    flex-direction: row;
    color: #000;
    font-size: 0.9rem;
    margin-top: 5px;
    font-weight: 500;
  }

  .segmentation {
    position: relative;
    width: 70vw;
    height: 1.5px;
    background-color: #b0b2b6;
    margin-top: 20px;
  }
  .ewmimg {
    width: 150px;
    height: 150px;
    margin-top: 20px;
    margin-left: 25%;
    margin-bottom: 20px;
    image-rendering: -webkit-optimize-contrast;
  }
  .ewm-tip {
    display: block;
    width: 100%;
    padding: 18px 0;
    margin: 32px 0 18px 0;
    font-size: 1.08rem;
    font-weight: 500;
    color: #00706E;
    background: #f5f7fa;
    border-left: 4px solid #15a2bb;
    text-align: center;
    letter-spacing: 1px;
    box-shadow: none;
    border-radius: 0;
    opacity: 1;
  }
  .ewm-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 240px;
    height: 80px;
    font-size: 1.35rem;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(90deg, #009688 0%, #15a2bb 100%);
    border: none;
    border-radius: 10px;
    margin: 36px auto 24px auto;
    cursor: pointer;
    box-shadow: 0 6px 24px rgba(21,162,187,0.18), 0 1.5px 6px rgba(0,0,0,0.08);
    transition: background 0.2s, box-shadow 0.2s;
    letter-spacing: 2px;
    outline: none;
    appearance: none;
    background-image: linear-gradient(90deg, #009688 0%, #15a2bb 100%);
  }
  .ewm-btn:active {
    background: linear-gradient(90deg, #00706E 0%, #009688 100%);
    box-shadow: 0 2px 8px rgba(21,162,187,0.12);
  }
  .ewm-btn:disabled {
    background: #b0b2b6;
    cursor: not-allowed;
    opacity: 0.7;
    box-shadow: none;
  }

  .active-list__new-activity-content-main {
    padding: 0rem 1.6rem 2.88rem 1.6rem;
  }

  .active-list__new-activity-content-title {
    font-size: 1.45rem;
    color: #00706E;
    line-height: 1rem;
    text-align: center;
  }

  .active-list__new-activity-content-bg {
    display: block;
    width: 100%;
  }

  .active-list__new-activity-content-describe {
    // text-align: center;
    margin-top: 1.5rem;

  }

  .active-list__new-activity-content-contact {
    margin-top: 30px;
    width: 50%;
    line-height: 40px;
    text-align: center;
    color: #fff;
    border-radius: 20px;
    margin-left: 25%;
    background: #00706E;
  }

  .active-list__item-info-detail-progress {
    margin-top: 0.88rem;
    display: flex;
    align-items: center;
  }

  .active-list__item-info-detail-progress-bar {
    flex: 1 1 auto;
    // height: 0.76rem;
    background: #f5f5f5;
    border-radius: 0.38rem;
    border: 1px solid #cbcbcb;
    padding: 2px;
    box-sizing: border-box;
  }

  .active-list__item-info-detail-progress-bar-inner {
    background: #00706E;
    border-radius: 0.27rem;
    height: 0.53rem;
  }

  .active-list__item-info-detail-progress-text {
    flex: 0 0 auto;
    margin-left: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniCard/AlumniCardComponents.vue